let ClientQuicksightURLUAT = () => {
  let client = localStorage.getItem('customerNo');

  switch (client) {
    case "1371":
      return {
        "VEHICLE_DOCUMENT_REPORT": '06e833b1-9ebd-4451-8c36-c584d2655663',
        "CURRENT_MONTH_JOBCARD_ANALYSIS": '651ebdd1-5749-43bd-aac0-dd5ae4a13cb0',
        "TRANSACTION_HISTORY_REPORT": 'ab0a4cca-ee88-4bf1-8af1-ba0602cf11fd',
        "CURRENT_TYRE_RUN_REPORT": '381b7842-9582-4a8f-937f-4c01846196e9',
        "HISTORIC_TYRE_RUN_REPORT": '1a6fd7e0-6956-4108-9c03-d985c5250cd2',
        "HISTORIC_BATTERY_REPORT": '704a0565-5baa-4e32-8438-bb0bd777169a'

      }
    case "503":
      return {
        "VEHICLE_DOCUMENT_REPORT": 'ebc79488-48fc-4eba-8a29-4064ca1a6918',
        "CURRENT_MONTH_JOBCARD_ANALYSIS": '8e14c5df-20f7-477a-b4a8-c28085540e63',
        "TRANSACTION_HISTORY_REPORT": '29b8130b-679f-4e71-a39e-6fd0ec882374',
        "CURRENT_TYRE_RUN_REPORT": '7186b77e-28dc-430c-8b70-18d16a9311fd',
        "HISTORIC_TYRE_RUN_REPORT": 'f33b8582-d6f9-4be4-bf6c-171af01599b0',
        "HISTORIC_BATTERY_REPORT": '16e4db26-ebde-4b18-9aae-62a720a1b89f'
      }
    default: //1158 Client
      return {
      }
  }
}

export default ClientQuicksightURLUAT();